import { Branch } from '../types/cart.types';

const PROSTE_MENU_DOMAINS = [
  'proste.menu',
  'test-klient.proste.menu',
  'localhost',
  '127.0.0.1'
];

export const isCustomDomain = (): boolean => {
  return !PROSTE_MENU_DOMAINS.some(domain => window.location.hostname === domain);
};

/**
 * Convert a legacy backend path string (e.g., "/menu/dishes") to a MenuPage object.
 */
export const legacyPathToPage = (path: string | undefined): { page: string } => {
  if (!path) return { page: 'dishes' };
  const cleanPath = path.replace(/^\/menu/, '').replace(/^\//, '');
  const pageName = cleanPath || 'dishes';
  switch (pageName) {
    case 'dishes': return { page: 'dishes' };
    case 'services': return { page: 'services' };
    case 'cart': return { page: 'cart' };
    case 'delivery': return { page: 'delivery' };
    case 'summary': return { page: 'summary' };
    case 'statute': return { page: 'statute' };
    default: return { page: 'dishes' };
  }
};

/**
 * Get the URL-safe slug for a branch.
 * Uses branch.slug if available, falls back to branch.id.
 */
export const getBranchSlug = (branch: Branch): string => {
  return branch.slug ?? branch.id;
};

/**
 * Find a branch from a list by matching a URL slug parameter.
 * Checks branch.slug first, then branch.id.
 */
export const findBranchBySlug = (
  branches: Branch[],
  urlSlug: string
): Branch | undefined => {
  return (
    branches.find((b) => b.slug === urlSlug) ??
    branches.find((b) => b.id === urlSlug)
  );
};

/**
 * Build the path to the branches/selection page.
 */
export const buildBranchesPath = (restaurantSlug: string | null): string => {
  if (isCustomDomain()) return '/';
  return `/${restaurantSlug}`;
};

/**
 * Build the path to a branch's menu page.
 * Requires branchSlug (multi-branch with explicit branch in URL).
 */
export const buildMenuPath = (
  restaurantSlug: string | null,
  branchSlug: string
): string => {
  if (isCustomDomain()) return `/${branchSlug}`;
  return `/${restaurantSlug}/${branchSlug}`;
};
